import axiosInstance from "./axiosConfig";
import { handleApiError } from "./errorHandler";

// ------------- Enroll Client APIs -----------------------

export const user_session_data_client = async (data) => {
  try {
    const response = await axiosInstance.get(
      `/api/user_session_data_client?userid=${data}`
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'user_session_data_client');
  }
};

export const enroll_client = async (data) => {
  try {
    const response = await axiosInstance.get(`/api/enroll_client?customerid=${data}`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'enroll_client');
  }
};

export const edit_client = async () => {
  try {
    const response = await axiosInstance.get(`/api/edit_client`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'edit_client');
  }
};

export const change_client = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.put(`/api/change_client`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'change_client');
  }
};

export const client_enroll = async (data) => {
  try {
    const response = await axiosInstance.put(`/api/client_enroll`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'client_enroll');
  }
};

export const delete_client = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/delete_client`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'delete_client');
  }
};

export const new_client = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/new_client`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'new_client');
  }
};

// ---------------------------- Manage Client APIs ------------------------

export const client_change = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.get(`/api/client_change?customerid=${data}`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'client_change');
  }
};

export const manage_client = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.get(`/api/manage_client?customerid=${data}`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'manage_client');
  }
};

export const change_plan = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.put(`/api/change_plan`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'change_plan');
  }
};

// ---------------------------- Topic Assignment APIs ------------------------

export const assign_topic = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.get(`/api/assign_topic?customerid=${data}`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'assign_topic');
  }
};

export const new_assign = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.get(`/api/new_assign?customerid=${data}`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'new_assign');
  }
};
 
export const add_assign = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/add_assign`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'add_assign');
  }
};

// -----------------------------Client Topic Categories-----------------------------

export const assigned_cat = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.get(`/api/assignedcat?customerid=${data}`, {customerid:data});
    return response;
  } catch (error) {
    throw handleApiError(error, 'assigned_cat');
  }
};

export const edittopcat = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.get(`/api/edittopcat?customerid=${data}`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'edittopcat');
  }
};

export const newcat = async (data) => {
  try {
    const response = await axiosInstance.put(`/api/newcat`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'newcat');
  }
};

export const editcat = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.get(`/api/editcat?customerid=${data}`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'editcat');
  }
};

export const changecat = async (data) => {
  try {
    const response = await axiosInstance.put(`/api/changecat`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'changecat');
  }
};

export const addcat = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/addcat`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'addcat');
  }
};
